document.addEventListener('DOMContentLoaded', function() {
  // Select all FAQ items
  const faqItems = document.querySelectorAll('.faq-item');

  faqItems.forEach(item => {
    const question = item.querySelector('.faq-question');
    const toggle = item.querySelector('.faq-toggle');

    question.addEventListener('click', () => {
      const isActive = item.classList.contains('active');

      if (isActive) {
        // Close the FAQ
        item.classList.remove('active');
        toggle.textContent = '+';
      } else {
        // Open the FAQ
        item.classList.add('active');
        toggle.textContent = '-';
      }
    });
  });
});
